import { render, staticRenderFns } from "./CardLessonIcon.vue?vue&type=template&id=b0ed2dbc&scoped=true&"
import script from "./CardLessonIcon.vue?vue&type=script&lang=js&"
export * from "./CardLessonIcon.vue?vue&type=script&lang=js&"
import style0 from "./CardLessonIcon.vue?vue&type=style&index=0&id=b0ed2dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ed2dbc",
  null
  
)

export default component.exports